import React from 'react'
import SEO from "../common/SEO";
import Footer from '../common/footer/_Footer';
import Separator from "../elements/separator/Separator";
import TopBar from '../common/header/_TopBar';
import Header from '../common/header/_Header';
import PhotoThanks from '../common/PhotoThanks';
import BoxRealizzazioni from '../elements/_BoxRealizzazioni';
import BoxApp from '../elements/_BoxApp';
import GATracker from '../gaTracker';

const SviluppoApp = () => {

    GATracker();

    return (
        <>
            <SEO title="Sviluppo app desktop e mobile" description={"Sviluppo app desktop e mobile"} />
            <main className="page-wrapper">

                <TopBar />
                <Header btnStyle="btn-small btn-icon" HeaderSTyle="header-not-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 height-550 bg_image" data-black-overlay="7" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-app.jpg)` }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner pt--80 text-center">

                                    <h1 className="title display-one">Sviluppo App<br />Mobile & Desktop</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PhotoThanks name="Rodion Kutsaev" link="frostroomhead" />
                {/* End Slider Area  */}

                <Separator />

                <BoxApp />                

                <Separator />

                <BoxRealizzazioni />

                <Footer />

            </main>
        </>
    )
}

export default SviluppoApp;
